<template lang="pug">
  .b-base-textarea
    textarea.__field(:placeholder="label" :class="{ error: !!error }" v-on="inputListeners") {{ value }}
    // todo add error node and styles if needed
</template>

<script>
export default {
  name: 'BaseTextarea',
  props: {
    value: String,
    type: String,
    label: String,
    error: String,
  },
  computed: {
    inputListeners() {
      return {
        ...this.$listeners,
        input: (event) => this.$emit('input', event.target.value),
      };
    },
  },
};
</script>

<style scoped lang="scss">
.base-textarea {
  &__field {
    display: block;
    width: 100%;
    min-height: 130px;
    padding: 12px 16px;
    resize: none;
    box-sizing: border-box;
    font-size: 13px;
    border-radius: 6px;
    background-color: var(--color-super-light);
    color: var(--color-dark-gray);
    outline: 0;
    font-weight: 500;

    &::placeholder {
      font-size: 13px;
      opacity: 1;
      font-weight: 500;
      color: var(--color-middle-gray);
    }
  }
}
</style>
